import { API_CORE_URL, API_URL } from "_config/constants/app.constants";
import { request } from "_utilities/request";
import { startTyC, startPrivacy, setPrivacy, setTyC, startLookAndFeel, setLookAndFeel } from "./slices";

export const fetchPartnerLookAndFeelThunk = (params, extras = {}) =>
  async (dispatch) => {
    dispatch(startLookAndFeel());
    let res = await request({
      endpoint: "",
      type: "get",
      params,
      ...extras
    });
    let { data, error } = res;
    dispatch(setLookAndFeel({ data, error }));
    return { data, error };
  };

export const fetchTyC = (params, extras = {}) => 
  async (dispatch) => {
    dispatch(startTyC());
    let res = await request({
      baseUrl: API_CORE_URL,
      endpoint: "/getter/terms-conditions",
      type: "get",
      params,
      ...extras
    });
    let { data, error } = res;
    dispatch(setTyC({ data: data?.[0], error }));
    return res;
  };

export const fetchPrivacy = (params, extras = {}) => 
  async (dispatch) => {
    dispatch(startPrivacy());
    let res = await request({
      baseUrl: API_CORE_URL,
      endpoint: "/getter/privacy-notice",
      type: "get",
      params,
      ...extras
    });
    
    const { data, error } = res;
    dispatch(setPrivacy({ data: data?.[0], error }));
    return res;
  };

export const fetchLookAndFeel = (params, extras = {}) =>
  async (dispatch) => {
    dispatch(startLookAndFeel());
    let res = await request({
      baseUrl: API_URL,
      endpoint: "/setting/lookAndFeel",
      withCredentials: true,
      params,
      ...extras
    });
    const { data, error } = res;
    
    dispatch(setLookAndFeel({ data, error }));
    return res;
  };
